module.exports = __webpack_public_path__ + "static/media/CasinoWar1.7e1ecf2a.png";